/**
 * @deprecated TS化済 src/utils/resources/registration/requestDivision.ts
 */
export const REQUEST_DIVISION_CANDIDATE_CLIENT = {
    cardLabel: 'クライアント企業として登録',
    id: 'client',
    label: '企業として登録する',
    name: {
        cardLabel: 'クライアント企業',
        label: '企業',
        proffitSearch: '事業会社',
        short: '企業として登録',
        veryShort: '企業',
    },
    short: '企業として登録',
    value: 1,
    veryShort: '企業',
};
/**
 * @deprecated TS化済 src/utils/resources/registration/requestDivision.ts
 */
export const REQUEST_DIVISION_CANDIDATE_PRO = {
    cardLabel: 'コンサルとして登録',
    id: 'professional',
    label: 'コンサルファームとして登録する',
    name: {
        cardLabel: 'コンサル',
        label: 'コンサルファーム',
        proffitSearch: 'コンサルファーム',
        short: 'コンサルとして登録',
        veryShort: 'コンサルファーム',
    },
    short: 'コンサルとして登録',
    value: 2,
    veryShort: 'コンサルファーム',
};
/**
 * @deprecated TS化済 src/utils/resources/registration/requestDivision.ts
 */
export const REQUEST_DIVISION_CANDIDATES = [
    REQUEST_DIVISION_CANDIDATE_CLIENT,
    REQUEST_DIVISION_CANDIDATE_PRO,
];
/**
 * 登録元種別: 登録画面
 * @deprecated TS化済 src/utils/resources/registration/registrationType.ts
 */
export const REGISTRATION_TYPE_NORMAL = 'REGISTRATION_NORMAL';
/**
 * 登録元種別: コラム
 * @deprecated TS化済 src/utils/resources/registration/registrationType.ts
 */
export const REGISTRATION_TYPE_COLUMN = 'REGISTRATION_COLUMN';
/**
 * 登録元種別: 資料
 * @deprecated TS化済 src/utils/resources/registration/registrationType.ts
 */
export const REGISTRATION_TYPE_DOCUMENT = 'REGISTRATION_DOCUMENT';
/**
 * 登録元種別: コンサルサーチ
 * @deprecated TS化済 src/utils/resources/registration/registrationType.ts
 */
export const REGISTRATION_TYPE_CONSULTANT_SEARCH = 'REGISTRATION_CONSULTANT_SEARCH';
/**
 * 登録元種別: コンサル詳細
 * @deprecated TS化済 src/utils/resources/registration/registrationType.ts
 */
export const REGISTRATION_TYPE_PROFESSIONAL_ONE = 'REGISTRATION_PROFESSIONAL_ONE';
/**
 * 登録元種別: コーポレートページ
 * @deprecated TS化済 src/utils/resources/registration/registrationType.ts
 */
export const REGISTRATION_TYPE_PROFESSIONAL_UNIT = 'REGISTRATION_PROFESSIONAL_UNIT';
/**
 * 登録元種別: セミナー
 * @deprecated TS化済 src/utils/resources/registration/registrationType.ts
 */
export const REGISTRATION_TYPE_SEMINAR_LIST = 'REGISTRATION_SEMINAR_LIST';
